var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import MaskedInput from 'react-text-mask';
import { View } from '@amzn/atoz-web/View';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var MASKS = {
    MILITARY: {
        BASE: [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/],
        AFTER_HOUR_20: [/[0-2]/, /[0-3]/, ':', /[0-5]/, /[0-9]/],
        BEFORE_HOUR_20: [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]
    },
    NONMILITARY: {
        BASE: [/[0-1]/, /[0-9]/, ':', /[0-5]/, /[0-9]/, ' ', /[APap]/, 'm'],
        AFTER_HOUR_10: [
            /[0-1]/,
            /[0-2]/,
            ':',
            /[0-5]/,
            /[0-9]/,
            ' ',
            /[APap]/,
            'm'
        ],
        BEFORE_HOUR_10: [
            /[0]/,
            /[1-9]/,
            ':',
            /[0-5]/,
            /[0-9]/,
            ' ',
            /[APap]/,
            'm'
        ]
    }
};
export var getInputMask = function (value, useMilitaryTime) {
    if (value === '' || value === undefined) {
        return useMilitaryTime ? MASKS.MILITARY.BASE : MASKS.NONMILITARY.BASE;
    }
    if (useMilitaryTime) {
        return value[0] === '2'
            ? MASKS.MILITARY.AFTER_HOUR_20
            : MASKS.MILITARY.BEFORE_HOUR_20;
    }
    else {
        return value[0] === '1'
            ? MASKS.NONMILITARY.AFTER_HOUR_10
            : MASKS.NONMILITARY.BEFORE_HOUR_10;
    }
};
export var TextTimeInput = function (_a) {
    var placeholder = _a.placeholder, dataTestId = _a.dataTestId, value = _a.value, onChange = _a.onChange, militaryTime = _a.militaryTime, className = _a.className, disabled = _a.disabled, hideFocusPlaceholder = _a.hideFocusPlaceholder, ariaLabel = _a.ariaLabel;
    var t = useTranslation().t;
    var useMilitaryTime = militaryTime !== null && militaryTime !== void 0 ? militaryTime : false;
    var focusedHandler = function (e) {
        if (!hideFocusPlaceholder) {
            e.target.placeholder = useMilitaryTime
                ? t('shift_management_feature_TextInput_Example_24')
                : t('shift_management_feature_TextInput_Example');
        }
    };
    var blurredHandler = function (e) {
        e.target.placeholder = placeholder;
    };
    return (React.createElement(TextTimeInputContainer, { dataTestId: "TextTimeInput" },
        React.createElement(MaskedInput, { disabled: disabled, className: className, type: "text", mask: getInputMask(value, useMilitaryTime), value: value, placeholder: placeholder, onChange: function (e) { return onChange(e.target.value); }, onFocus: function (e) { return focusedHandler(e); }, onBlur: function (e) { return blurredHandler(e); }, id: dataTestId, "data-testid": dataTestId, "aria-label": ariaLabel })));
};
var TextTimeInputContainer = styledWithTheme(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t     .form-control {\n\t         height: 200%;\n\t     }\n\t \n\t     input[type='text'] {\n\t         background-repeat: no-repeat;\n\t         background-position: 12px center;\n\t         height: 45px;\n\t         width: 100%;\n\t         padding: 6px 8px;\n\t     }\n\t \n\t     .error {\n\t         border: 1px solid #cd3e3e;\n\t     }\n\t "], ["\n\t     .form-control {\n\t         height: 200%;\n\t     }\n\t \n\t     input[type='text'] {\n\t         background-repeat: no-repeat;\n\t         background-position: 12px center;\n\t         height: 45px;\n\t         width: 100%;\n\t         padding: 6px 8px;\n\t     }\n\t \n\t     .error {\n\t         border: 1px solid #cd3e3e;\n\t     }\n\t "])));
var templateObject_1;
